import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {DataService} from './data.service';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {GenericResponse} from '../model/Responses/GenericResponse';
import { ToastController } from '@ionic/angular';

@Injectable({
    providedIn: 'root'
})
export class GenericCrudService<T> {

    private routeBase : string = '';

    private data: DataService;
    private h: HttpClient;
    private tc: ToastController;

    constructor(dataService: DataService, http: HttpClient, route, tc: ToastController) {
        this.data = dataService;
        this.h = http;
        this.routeBase = route;
        this.tc = tc;
    }



    public create(obj: T): Observable<GenericResponse<T>> {
        return this.h.post<GenericResponse<T>>(`${this.routeBase}/`, obj, this.data.getHttpOptions());
    }
    public update(obj: T): Observable<GenericResponse<T>> {
        let id = undefined;
        if(obj.hasOwnProperty('id')){
            // @ts-ignore
            id = obj.id;
        }
        return this.h.put<GenericResponse<T>>(`${this.routeBase}/${id}/`, obj, this.data.getHttpOptions());
    }
    public delete(id: string): Observable<GenericResponse<string>> {
        return this.h.delete<GenericResponse<string>>(`${this.routeBase}/${id}/`, this.data.getHttpOptions());
    }
    public get(id: string): Observable<GenericResponse<T>> {
        return this.h.get<GenericResponse<T>>(`${this.routeBase}/${id}/`, this.data.getHttpOptions());
    }
    public getAll(): Observable<GenericResponse<T[]>> {
        return this.h.get<GenericResponse<T[]>>(`${this.routeBase}/all/all/`, this.data.getHttpOptions());
    }
    public handleError(err: HttpErrorResponse, display1: string, display2: string): void {
        switch (err.status) {
            case 403:
                this.handleToast(`Sie besitzen nicht die Rechte um ${display1} laden zu können!`);
                break;
            case 404:
                this.handleToast(`${display2} wurde nicht gefunden!`);
                break;
        
            default:
                console.log(err);
                break;
        }
    }
    private async handleToast(msg: string, color: string = 'danger'): Promise<void> {
      const toast = await this.tc.create({
        message: msg,
        duration: 2000,
        color,
      });
      await toast.present();
    }
}
